import { render, staticRenderFns } from "./inOutAreaDetailList.vue?vue&type=template&id=b4b2638a&scoped=true"
import script from "./inOutAreaDetailList.vue?vue&type=script&lang=js"
export * from "./inOutAreaDetailList.vue?vue&type=script&lang=js"
import style0 from "./inOutAreaDetailList.vue?vue&type=style&index=0&id=b4b2638a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b2638a",
  null
  
)

export default component.exports